import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AssetsService {
    assets = {
        adele: {
            logo: 'logo.svg',
            logo2: 'logo-2.png',
            'logo-panel': 'logo-white.svg',
            'logo-splash-screen': 'logo-white.svg',
            favicon: 'favicon-32x32.png',
            title: 'ADELE',
            signinTitle: 'WELCOME',
            signinDesc: 'ADELE-IS-YOUR-PERSONAL-HEALTH-ASSISTANT',
            ALPHA: 'ADELE',
            WE_HAVE_FOUND_THESE_CONTACTS_IN_THE_ALPHA_ECOSYSTEM:
                'WE-HAVE-FOUND-THESE-CONTACTS-IN-THE-ADELE-ECOSYSTEM',
            fontFamilty:
                '"Montserrat Variable", "Montserrat", ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
        },
        juh: {
            logo: 'logo.svg',
            logo2: 'logo-2.svg',
            'logo-panel': 'logo.svg',
            'logo-splash-screen': 'logo.svg',
            favicon: 'favicon.ico',
            title: 'JOHANNITER',
            signinTitle: 'WELCOME',
            signinDesc: 'JUH-IS-YOUR-PERSONAL-HEALTH-ASSISTANT',
            ALPHA: 'JOHANNA',
            WE_HAVE_FOUND_THESE_CONTACTS_IN_THE_ALPHA_ECOSYSTEM:
                'WE-HAVE-FOUND-THESE-CONTACTS-IN-THE-JOHANNA-ECOSYSTEM',
            fontFamilty:
                '"Maven Pro Variable", "Maven Pro", ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
        },
    };

    /**
     * Constructor
     */
    constructor() {}
}
